import { Stack, Typography } from '@mui/material';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ItemCardProps as Props } from './types';

export const ItemCard = memo(
  ({ className, children, title, creditCost }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('ReportCard', className)}
        sx={SX.root}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={SX.header}
        >
          {title}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            gap={0.5}
          >
            {creditCost && (
              <>
                <Typography sx={SX.costTitle}>Credit Cost:</Typography>
                <Typography sx={SX.cost}>{creditCost}</Typography>
              </>
            )}
          </Stack>
        </Stack>
        {children}
      </Styled.Wrapper>
    );
  }
);

ItemCard.displayName = 'ItemCard';
